module.exports = __webpack_public_path__ + "img/photo04_sp.298dcbe9.jpg";